import { createPostRequestOpts, fetchJsonQuery } from "@mne-core/api";
import type { IRequestOpts, IResultstash } from "@mne-core/api";
import { QueryController, createUrl } from "@mne-core/api";

export interface IVerifyEnrollmentAndAuthorizeCriteria {
  userID: number | string;
  verificationCode: string;
  activationCookie: string;
}

export interface IVerifyEnrollmentAndAuthorizeResponse {
  credentials: {
    uri: string;
    clientIP: string;
    forwardedIP: string;
    requestCredentialsType: "sessionToken" | "signature" | "apikey";
    requestCredentialsData: string;
  };
  sessionKey: string;
  authorizations: {
    authorization: string;
    expires: number;
    identifier: "enrollPublicKeyMobile" | "enrollPublicKey" | "setPassword" | "initializeTOTP";
    nextURI: string;
    operation: string;
  }[];
}

export const createRequest = (
  { ...restCriteria }: IVerifyEnrollmentAndAuthorizeCriteria,
  opts: IRequestOpts,
): Request => {
  const { apiUrl, sessionKey, ...restOpts } = opts;
  const uri = createUrl(apiUrl, ["authentication", "v1", "enroll", "authentication"]).toString();
  return new Request(uri, createPostRequestOpts(JSON.stringify(restCriteria), { ...restOpts }));
};

export const verifyEnrollmentAndAuthorize = async (
  criteria: IVerifyEnrollmentAndAuthorizeCriteria,
  opts: IRequestOpts,
) =>
  fetchJsonQuery<IResultstash<IVerifyEnrollmentAndAuthorizeResponse>>(createRequest(criteria, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
